import { defineStore } from 'pinia'
import { ILogin } from './types'
import { AUTH_TOKEN, AUTH_REFRESH } from 'core/constants'
import { login } from '@/api/auth'
import { useState } from './state'

export const useActions = defineStore('auth.actions', () => {
  const actLogin = async (_: ILogin) => {
    const { email, password } = _
    const result = await login(email, password);
    if (result.success) {
      console.log("Access esiste:");
      window.location.href = '/dashboard';
      return { success: true };
    } else {
      console.log("Access non esiste", result.error);
      return { success: false, error: result.error };
    }
  }
  const actLogout = () => {
    const authState = useState()
    authState.removeUser()
    authState.removeTokens()
    authState.removeMenu()
    window.location.href = '/login'
  }
  
  return {
    actLogin,
    actLogout,
  }
})
